import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CompanyTypeBody from "components/AdministrationComponents/CompanyType/CompanyTypeBody";

const CompanyType = () => {
  useEffect(() => {
    document.title = "Administration | Company Type";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <CompanyTypeBody />
    </main>
  );
};

export default CompanyType;
